<ng-container *transloco="let t">
  <div
    class="d-flex justify-content-between align-items-stretch race-grid-item__header pe-20 {{cssClass ? cssClass : ''}}"
    [class.is-admin]="isAdmin">
    <div class="race-grid-item__length d-flex align-items-center justify-content-center">
      <span class="{{cssClass ? cssClass : ''}}">
        @if (showName) {
          <app-language-output [hrLabel]="race?.name" [enLabel]="race?.nameEng" [itLabel]="race?.nameIta"
                               [siLabel]="race?.nameSlo" [defaultLanguage]="defaultLanguage" [languages]="languages"/>

        } @else {
          {{ race?.length ? (race?.length | raceLengthFormat:translocoService.getActiveLang()) : '-' }}
        }
      </span>

    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div class="race-grid-item__type-label trim-text d-flex align-items-center {{cssClass ? cssClass : ''}}">
        {{ race?.sport ? t("app.common.sports." + race?.sport) : '' }}
      </div>
      @if (showExportButton) {
        <ng-container>
          <div class="vertical-separator-item"></div>
          <div class="text-uppercase cursor-pointer race-grid-item__label">
            {{ t("app.common.export.to.pdf") }}
          </div>
        </ng-container>
      }
    </div>
  </div>
</ng-container>
